import { useEffect, useState } from 'react';
const addListener = (mediaQuery, handler) => {
    if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', handler);
    }
    else if (mediaQuery.addListener) {
        // Safari v.<=13 safe exit
        mediaQuery.addListener(handler);
    }
};
const removeListener = (mediaQuery, handler) => {
    if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handler);
    }
    else if (mediaQuery.removeListener) {
        // Safari v.<=13 safe exit
        mediaQuery.removeListener(handler);
    }
};
export const supportsMatchMedia = () => !!window.matchMedia;
let mediaQuery = {};
export const resetCache = () => {
    mediaQuery = {};
};
export const useMediaQuery = (query, defaultValue = false) => {
    const [matchesQuery, setMatchesQuery] = useState(mediaQuery[query]?.matches ?? defaultValue);
    useEffect(() => {
        if (!supportsMatchMedia()) {
            return undefined;
        }
        if (!mediaQuery[query]) {
            mediaQuery[query] = window.matchMedia(query);
        }
        setMatchesQuery(mediaQuery[query].matches);
        const handler = ({ matches }) => setMatchesQuery(matches);
        addListener(mediaQuery[query], handler);
        return () => removeListener(mediaQuery[query], handler);
    }, [query]);
    return matchesQuery;
};
